import React, { useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Paper, Box, Typography, IconButton, Alert } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useRouter } from "next/navigation";

import s from "./styles";

import { dayjs, logjs, providers } from "@lib/client";
const { useWebAppContext } = providers;
import { useDownloadDialog } from "./useDownloadDialog";

const log = new logjs("DownloadDialog");

/**
 * ダウンロードダイアログコンポーネント
 * htdocs_ab/app/views/dl/index.ctp の内容を完全に反映
 * @param {Object} props - コンポーネントのプロパティ
 * @param {boolean} props.open - ダイアログの表示状態
 * @param {Function} props.onClose - ダイアログを閉じる際のコールバック関数
 * @param {Object} props.params - パラメータ（請求書情報等）
 */
function DownloadDialog({ open, onClose, params }) {
  log.debug("DownloadDialog", { open, onClose, params });
  const router = useRouter();
  //const { page_title = "請求書", gyoshu_flg = 1 } = params;

  const { state, actions, params: contextParams, searchParams: contextSearchParams } = useWebAppContext();
  const { IsLoading } = state;

  const [formData, formProps] = useDownloadDialog(state, actions, contextParams);
  const { downloadData, error } = formData;

  const { partsAry, page_title, gyoshu_flg } = downloadData;

  // ダイアログを開く
  useEffect(() => {
    if (open) {
      formProps.init();
    }
  }, [open]);

  // ダイアログを閉じる処理
  const handleClose = () => {
    onClose();
  };
  if (IsLoading) {
    return <s.Loading>Loading...</s.Loading>;
  }
  // ダウンロード一覧の表示（htdocs_ab/app/views/dl/index.ctp の構造を完全に再現）
  const renderDownloadList = () => {
    log.debug("renderDownloadList", { partsAry, page_title, gyoshu_flg });
    if (!partsAry || Object.keys(partsAry).length === 0) {
      return <s.EmptyMessage>{gyoshu_flg === 1 ? "お支払はありません。" : "ご請求はありません。"}</s.EmptyMessage>;
    }

    return (
      <s.DownloadTable>
        <tbody>
          {(() => {
            if (Object.keys(partsAry).length === 0) {
              return <s.EmptyMessage>ダウンロード対象が指定されていません。</s.EmptyMessage>;
            }
            const downloadRows = [];
            let rowIndex = 0;
            for (let k in partsAry) {
              const item = partsAry[k];
              rowIndex++;
              downloadRows.push(
                <s.DownloadRow key={`${item.kdate}-${rowIndex}`}>
                  <s.DownloadCell width="auto">
                    <span style={{ display: "inline-block", width: "20px", textAlign: "center" }}>・</span>
                  </s.DownloadCell>
                  <s.DownloadCell width="60%">
                    <s.DownloadLink
                      href="#"
                      onClick={async (e) => {
                        e.preventDefault();

                        const sd = dayjs(item.sd).format("YYYYMMDD");

                        window.open(`/dl/documents_print/${sd}`, "_blank");
                        /*
                        if (formProps.downloadDocument) {
                          await formProps.downloadDocument(item.kdate);
                        }
                          */
                      }}
                      style={{ backgroundColor: rowIndex % 2 === 0 ? "#b3ffcc" : "#b3ffff" }}
                    >
                      {item.hyouji}
                    </s.DownloadLink>
                  </s.DownloadCell>
                  <s.DownloadCell width="40%">
                    {item.dlflg === 1 && (
                      <>
                        {item.etsuran} <s.ViewedStatus>閲覧済</s.ViewedStatus>
                      </>
                    )}
                  </s.DownloadCell>
                </s.DownloadRow>
              );
            }
            return downloadRows;
          })()}
        </tbody>
      </s.DownloadTable>
    );
  };

  const isModal = false;
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      // PaperProps={{
      //   sx: {
      //     minHeight: "400px",
      //     maxHeight: "90vh",
      //   },
      // }}
      hideBackdrop={isModal}
      style={!isModal ? { pointerEvents: "none" } : { pointerEvents: "auto" }}
      BackdropProps={
        !isModal
          ? {
              style: { pointerEvents: "none" }, // 背景は操作不可にする
            }
          : {}
      }
      PaperProps={
        !isModal
          ? {
              style: { pointerEvents: "auto" }, // ダイアログ自体は操作可能にする
              sx: {
                minHeight: "400px",
                maxHeight: "90vh",
              },
            }
          : {}
      }
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          /* borderBottom: "1px solid #e0e0e0", */
          background: "url(../images/bg.png) 0 0",
        }}
      >
        <Typography
          variant="h5"
          component="div"
          sx={{
            background: "url(../images/window_title.png) no-repeat 0 50%",
            padding: "5px 0 0 35px",
            color: "#333",
            fontSize: "24px",
            lineHeight: "30px",
            marginBottom: "10px",
          }}
        >
          {page_title || "計算書"}ダウンロード
        </Typography>
        <IconButton onClick={handleClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: 1, background: "url(../images/bg.png) 0 0" }}>
        <s.DownloadContainer>
          {/* 注文詳細情報（htdocs_ab/app/views/dl/index.ctp の order_detail クラスを再現） 
          <s.OrderDetail>
            <s.OrderDetailTitle>{page_title}ダウンロード</s.OrderDetailTitle>
          </s.OrderDetail>
          */}

          {/* エラーメッセージ */}
          {error && <s.ErrorMessage>{error}</s.ErrorMessage>}

          {/* ダウンロード一覧（htdocs_ab/app/views/dl/index.ctp の構造を完全に再現） */}
          <s.DownloadListContainer>{renderDownloadList()}</s.DownloadListContainer>
        </s.DownloadContainer>
      </DialogContent>

      <DialogActions sx={{ p: 2, background: "url(../images/bg.png) 0 0" }}>
        {/*
        <Button
          onClick={handleClose}
          variant="contained"
          sx={{
            background: "#666",
            color: "#FFF",
            "&:hover": {
              background: "#555",
            },
          }}
        >
          閉じる
        </Button>
        */}
      </DialogActions>
    </Dialog>
  );
}

export default DownloadDialog;
